import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../../components/LinkIcon";

import "./styles.less";
const isWindow = () => typeof window !== "undefined";
const isDocument = () => typeof document !== "undefined";
export const SolutionSceneScreen = (props) => {
  const { t } = useTranslation();
  const { list, hasDoc } = props;
  const [topValue, setTopValue] = useState("0px");
  const [bottomValue, setBottomValue] = useState();
  const [scrollTop, setScrollTop] = useState(0);
  const [bannerIndex, setBannerIndex] = useState(0);
  const [element, setElement] = useState(0);
  const scrollHandler = useCallback(() => {
    if (isDocument()) {
      const chrildElement =
        isDocument() && document.querySelector(".bannerBox-right-chrild");
      const documentScrollTop =
        (isDocument() && document.body.scrollTop) ||
        document.documentElement.scrollTop;
      const selfHeight =
        isWindow() &&
        Number(window.getComputedStyle(chrildElement).height.split("px")[0]);
      if (topValue < documentScrollTop) {
        const index = Math.round((documentScrollTop - topValue) / selfHeight);
        if (index < list.length) {
          setBannerIndex(index);
        }
      }
      setScrollTop(documentScrollTop);
    }
  });
  useEffect(() => {
    scrollHandler();
  }, [scrollHandler]);
  useEffect(() => {
    isWindow() && window.addEventListener("scroll", scrollHandler);
    return () => {
      isWindow() && window.removeEventListener("scroll", scrollHandler);
    };
  }, [scrollHandler]);
  useEffect(() => {
    if (isWindow()) {
      const bannerBox = document.getElementById("bannerBox");
      if (bannerBox) {
        setTopValue(bannerBox.offsetTop);
        setBottomValue(
          isWindow() &&
            Number(window.getComputedStyle(bannerBox).height.split("p")[0]) +
              topValue,
          +"px"
        );
      }
    }
  }, [scrollHandler, topValue]);
  const clientHeight =
    (isDocument() && document.documentElement.clientHeight) || "";
  const cls = classNames({
    "bannerBox-left": true,
    fixed:
      scrollTop + 80 > topValue && scrollTop + clientHeight < bottomValue
        ? true
        : false,
    bottom: scrollTop + clientHeight > bottomValue ? true : false,
  });
  const nextFun = () => {
    if (element >= list.length - 1) {
      setElement(0);
    } else {
      setElement(element + 1);
    }
  };
  const lastFun = () => {
    if (element <= 0) {
      setElement(list.length - 1);
    } else {
      setElement(element - 1);
    }
  };
  const renderScrollScreenMobile = () => {
    return (
      <div className="solution-scene-screen-mobile">
        <div
          className="last-button"
          onClick={() => {
            lastFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(-90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
        <div className="solution-scene-screen-content">
          {list.map((item, index) => {
            if (element === index) {
              return (
                <>
                  <div className="value-text-title">{item.subLabel}</div>
                  <div className="value-text-context">{item.content}</div>
                  <div style={{ textAlign: "center" }}>
                    {hasDoc && (
                      <Link href={item.docLink} target="_blank">
                        {t("common.button.linkDoc")}
                      </Link>
                    )}
                  </div>
                  <div className="value-text-img">
                    <img src={item.imgUrl} alt={item.alt} />
                  </div>
                </>
              );
            } else {
              return null;
            }
          })}
        </div>
        <div
          className="next-button"
          onClick={() => {
            nextFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
      </div>
    );
  };
  const renderScrollScreen = () => {
    return (
      <div className="solution-scene-screen">
        <div className="scene-screen-box">
          <div className="banner-connection" id="bannerBox">
            <div className={cls}>
              <div className="index-box">
                {list.map((item, index) => {
                  return (
                    <li className={bannerIndex === index ? "li" : ""}></li>
                  );
                })}
              </div>
              <div className="info-box">
                {list.map((item, index) => {
                  return (
                    <div
                      className="info-box-item"
                      key={"info-box" + index}
                      style={
                        bannerIndex === index
                          ? { display: "block" }
                          : { display: "none" }
                      }
                    >
                      <div className="info-box-item-title">{item.subLabel}</div>
                      <div className="info-box-item-content">
                        {item.content}
                      </div>
                      {hasDoc && (
                        <Link href={item.docLink} target="_blank">
                          {t("common.button.linkDoc")}
                        </Link>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="bannerBox-list">
              {list.map((item, index) => {
                return (
                  <div key={"bannerBox-right" + index}>
                    <div className="bannerBox-right">
                      <div className="bannerBox-right-chrild">
                        <img
                          src={item.imgUrl}
                          alt={item.alt}
                          style={{ zIndex: "2" }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      {renderScrollScreen()}
      {renderScrollScreenMobile()}
    </>
  );
};
